import React from 'react';
import styles from '../ListLenders/ListLenders.css';

class PromoLink extends React.Component {
  handleClick = e => {
    e.preventDefault();
    this.props.onLinkClick(this.props.value);
  };

  render() {
    return (
      <a className={`${styles.link}`} onClick={this.handleClick}>
        {this.props.notes}
      </a>
    );
  }
}

export default PromoLink;
